import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { resetFilter } from 'redux/actions/newFilter';
import {
  getEmployeeRole,
  activateEmployeeRole,
  deactivateEmployeeRole,
} from '../../redux/actions/employee';

import EmployeeRoleListPage from './EmployeeRoleList.page';

const mapStateToProps = state => ({
  employeeRoleList: state.organization.employeeRolesAll,
  getLoading: state.organization.getLoading,
  pagination: state.organization.pagination,
  filterValue: state.newFilter.filterValue,
  formControlShow: state.newFilter.formControlShow,
});

const mapDispatchToProps = {
  getEmployeeRole,
  activateEmployeeRole,
  deactivateEmployeeRole,
  resetFilter,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(EmployeeRoleListPage));
